var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCardId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5C4.54774 13.5 4.59695 13.5 4.64768 13.5H9M4.5 13.5C3.7588 13.4994 3.37 13.4901 3.06885 13.3367C2.7866 13.1929 2.5573 12.9628 2.41349 12.6805C2.25 12.3597 2.25 11.9402 2.25 11.1001V6.90015C2.25 6.06007 2.25 5.63972 2.41349 5.31885C2.5573 5.0366 2.7866 4.8073 3.06885 4.66349C3.38972 4.5 3.81007 4.5 4.65015 4.5H13.3501C14.1902 4.5 14.6097 4.5 14.9305 4.66349C15.2128 4.8073 15.4429 5.0366 15.5867 5.31885C15.75 5.6394 15.75 6.05925 15.75 6.89768V11.1023C15.75 11.9408 15.75 12.36 15.5867 12.6805C15.4429 12.9628 15.2128 13.1929 14.9305 13.3367C14.61 13.5 14.1908 13.5 13.3523 13.5H9M4.5 13.5C4.50003 12.6716 5.50738 12 6.75 12C7.99264 12 9 12.6716 9 13.5M4.5 13.5C4.5 13.5 4.5 13.5 4.5 13.5ZM13.5 10.5H10.5M13.5 8.25H11.25M6.75 9.75C5.92157 9.75 5.25 9.07843 5.25 8.25C5.25 7.42157 5.92157 6.75 6.75 6.75C7.57843 6.75 8.25 7.42157 8.25 8.25C8.25 9.07843 7.57843 9.75 6.75 9.75Z",
    stroke: "#413F5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCardId);
export default __webpack_public_path__ + "static/media/UserCardId.23f113348f0c96da446b83337fc9a104.svg";
export { ForwardRef as ReactComponent };